import { locale } from "../locales";

/**
 * Storefront CustomerErrorCode + Customer Account API userErrors code 를 문구로 변환
 */
export const customerErrorHandler = (code: string | null | undefined, lang: "ko" | "en" | "jp"): string => {
  const messages: Record<string, string> = locale(lang).customer_error;
  return (code && messages[code]) || messages.DEFAULT;
};

export const cartErrorHandler = (code: string | null | undefined, lang: "ko" | "en" | "jp"): string => {
  const messages: Record<string, string> = locale(lang).cart_error;
  return (code && messages[code]) || messages.DEFAULT;
};
